import { ReactNode } from 'react';

import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminNavigation';

type Props = {
    children: ReactNode;
};

export default function AdminLayout({
                                        children,
                                    }: Props) {

    return (
        <div className="admin-layout">

            <AdminHeader />

            <div className="admin-body">

                <AdminSidebar />

                <main className="admin-content">
                    {children}
                </main>

            </div>

        </div>
    );
}
